// extracted by mini-css-extract-plugin
export default {"root":"FieldInfo_root__khiKY"};